import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { environment } from '../../../../environments/environment';

export interface ConfirmDialogData {
  title: string;
  message: string;
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent {
  private dialog = inject(MatDialogRef<ConfirmDialogComponent>);
  assetUrl = environment.assetBaseUrl

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData) {}

  // ❌ Cancel
  closeDialog(): void {
    this.dialog.close(false);
  }

  // ✅ Confirm Delete
  confirmDelete(): void {
    this.dialog.close(true);
  }
}
